import store from '@/store'
import { GLOBAL_REGION, GLOBAL_BRAND, ALL_PERMISSION } from './constants';

/**
 * User permission verification
 * @param {Array} value 
 * @returns {Boolean}
 */
export function checkPermission(value) {
  if (!value) {
    throw new Error("User permission to check could not be empty");
  }

  console.log('checkPermission:', value);

  let permToCheck = value;

  // Check if user have global permission 
  let globalPermList = store.getters.permissionMap?.[GLOBAL_REGION]?.[GLOBAL_BRAND] || [];
  // Check if user has admin permission
  if (globalPermList.includes(ALL_PERMISSION)) {
    return true;
  }

  // Check if user have brand permission
  let brandPermList = store.getters.permissionMap?.[store.getters.region]?.[store.getters.brand] || [];
  // Combine user global and brand permission
  let userPermList = globalPermList.concat(brandPermList);
  if (userPermList.length == 0) {
    return false;
  }

  // If input permission to be checked is array
  if (permToCheck instanceof Array && permToCheck.length > 0) {
    return userPermList.some(item => {
      return permToCheck.includes(item);
    })
  } else {
    return userPermList.some(item => {
      return item === permToCheck;
    })
  }

}

/**
 * User role verification
 * @param {Array} value 
 * @returns {Boolean}
 */
export function checkRole(value) {
  if (!value) {
    throw new Error("User role to check could not be empty");
  }
  let roleToCheck = value;

  // Check if user have global permission 
  let globalRoleList = store.getters.roleMap?.[GLOBAL_REGION]?.[GLOBAL_BRAND] || [];
  // Check if user has admin permission
  if (globalRoleList.includes(ALL_PERMISSION)) {
    return true;
  }

  // Check if user have brand permission
  let brandRoleList = store.getters.roleMap?.[store.getters.region]?.[store.getters.brand] || [];
  // Combine user global and brand permission
  let userRoleList = globalRoleList.concat(brandRoleList);
  if (userRoleList.length == 0) {
    return false;
  }

  // If input permission to be checked is array
  if (roleToCheck instanceof Array && roleToCheck.length > 0) {
    return userRoleList.some(item => {
      return roleToCheck.includes(item);
    })
  } else {
    return userRoleList.some(item => {
      return item === roleToCheck;
    })
  }
}